/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// slick slider
$('.slider_1').slick({
    arrows:false,
});
$('.slick-thumb_1').slick({
    asNavFor:'.slider_1',
    focusOnSelect:true,
    slidesToShow:3,
    slidesToScroll:1
}); 


$('.slider_2').slick({
    arrows:false,
});
$('.slick-thumb_2').slick({
    asNavFor:'.slider_2',
    focusOnSelect:true,
    slidesToShow:3,
    slidesToScroll:1
}); 


$('.slider_3').slick({
    arrows:false,
});
$('.slick-thumb_3').slick({
    asNavFor:'.slider_3',
    focusOnSelect:true,
    slidesToShow:3,
    slidesToScroll:1
}); 


$('.slider_4').slick({
    arrows:false,
});
$('.slick-thumb_4').slick({
    asNavFor:'.slider_4',
    focusOnSelect:true,
    slidesToShow:3,
    slidesToScroll:1
}); 